export default __webpack_public_path__ + "static/media/my-cv.d39501ea.pdf";